import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style", "className", "css", "children", "direction", "spacing", "align", "justify", "wrap", "shouldFitContainer"];
import React from "react";
import { BaseStack } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Stack(_ref) {
  var as = _ref.as,
    style = _ref.style,
    className = _ref.className,
    css = _ref.css,
    children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? "vertical" : _ref$direction,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? "md" : _ref$spacing,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? "start" : _ref$align,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? "start" : _ref$justify,
    wrap = _ref.wrap,
    shouldFitContainer = _ref.shouldFitContainer,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseStack, _extends({
    direction: direction,
    align: align,
    justify: justify,
    spacing: spacing,
    wrap: wrap,
    shouldFitContainer: shouldFitContainer
  }, restProps, {
    children: children
  }));
}
export default Stack;